// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-size[data-v-4c6e4920]{font-size:3.5rem}.check-icon[data-v-4c6e4920]{font-size:2.5rem}.limit-width[data-v-4c6e4920]{max-width:25rem}.light-mode .hover-color[data-v-4c6e4920] .o-upl__draggable--hovered{background-color:#fff0f8}.dark-mode .hover-color[data-v-4c6e4920] .o-upl__draggable--hovered{background-color:#363234}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
